// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.concierge-quotation-approval-modal {
  max-width: 768px;
}
.concierge-quotation-approval-modal .ant-modal-content {
  padding: var(--spacing-big) var(--spacing-small) !important;
}
.concierge-quotation-approval-modal .note-container,
.concierge-quotation-approval-modal .note {
  margin-top: var(--spacing-small);
}
.concierge-quotation-approval-modal .note-container .note-checkbox span,
.concierge-quotation-approval-modal .note .note-checkbox span {
  padding: 0;
}
.concierge-quotation-approval-modal .action-btn-group {
  margin-top: var(--spacing-regular);
}
.concierge-quotation-approval-modal .action-btn-group .next-step-btn {
  display: flex;
  gap: var(--spacing-extra-small);
}
.concierge-quotation-approval-modal .btn-term-upload .ant-upload-list {
  margin-top: var(--spacing-extra-small);
}
.btn-approve.vert-button[disabled].ant-btn-default span {
  color: var(--color-neutral) !important;
}
.btn-approve.vert-button:not([disabled]).ant-btn-highlight {
  background-color: var(--color-highlight) !important;
}
.btn-approve.vert-button:not([disabled]).ant-btn-highlight:hover {
  background-color: var(--color-highlight-darker) !important;
}
.btn-approve.vert-button:not([disabled]).ant-btn-default {
  border-color: var(--color-highlight) !important;
  color: var(--color-highlight) !important;
}
.btn-approve.vert-button:not([disabled]).ant-btn-default:hover {
  border-color: var(--color-border) !important;
}
@media (max-width: 768px) {
  .concierge-quotation-approval-modal {
    width: 80% !important;
  }
  .button-concierge,
  .btn-approve {
    flex-direction: column !important;
    width: 100% !important;
  }
}
@media (max-width: 425px) {
  .concierge-quotation-approval-modal {
    width: 90% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Concierge/Modals/QuotationApprovalModal.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AAFA;EAII,2DAAA;AACJ;AALA;;EAQI,gCAAA;AACJ;AATA;;EAYQ,UAAA;AACR;AAbA;EAkBI,kCAAA;AAFJ;AAhBA;EAqBM,aAAA;EACA,+BAAA;AAFN;AApBA;EA4BM,sCAAA;AALN;AAUA;EAEI,sCAAA;AATJ;AAaA;EACE,mDAAA;AAXF;AAcA;EACE,0DAAA;AAZF;AAeA;EACE,+CAAA;EACA,wCAAA;AAbF;AAgBA;EACE,4CAAA;AAdF;AAiBA;EACE;IACE,qBAAA;EAfF;EAiBA;;IACE,iCAAA;IACA,sBAAA;EAdF;AACF;AAiBA;EACE;IACE,qBAAA;EAfF;AACF","sourcesContent":[".concierge-quotation-approval-modal {\n  max-width: 768px;\n\n  .ant-modal-content {\n    padding: var(--spacing-big) var(--spacing-small) !important;\n  }\n\n  .note-container, .note {\n    margin-top: var(--spacing-small);\n\n    .note-checkbox {\n      span {\n        padding: 0;\n      }\n    }\n  }\n\n  .action-btn-group {\n    margin-top: var(--spacing-regular);\n\n    .next-step-btn {\n      display: flex;\n      gap: var(--spacing-extra-small);\n    }\n  }\n\n  .btn-term-upload {\n    .ant-upload-list {\n      margin-top: var(--spacing-extra-small);\n    }\n  }\n}\n\n.btn-approve.vert-button[disabled].ant-btn-default {\n  span {\n    color: var(--color-neutral) !important;\n  }\n}\n\n.btn-approve.vert-button:not([disabled]).ant-btn-highlight {\n  background-color: var(--color-highlight) !important;\n}\n\n.btn-approve.vert-button:not([disabled]).ant-btn-highlight:hover {\n  background-color: var(--color-highlight-darker) !important;\n}\n\n.btn-approve.vert-button:not([disabled]).ant-btn-default {\n  border-color: var(--color-highlight) !important;\n  color: var(--color-highlight) !important;\n}\n\n.btn-approve.vert-button:not([disabled]).ant-btn-default:hover {\n  border-color: var(--color-border) !important;\n}\n\n@media (max-width: 768px) {\n  .concierge-quotation-approval-modal {\n    width: 80% !important;\n  }\n  .button-concierge, .btn-approve{\n    flex-direction: column !important;\n    width: 100% !important;\n  }\n}\n\n@media(max-width: 425px){\n  .concierge-quotation-approval-modal {\n    width: 90% !important;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
